import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowMeterReportComponent } from './flow-meter-report.component';
import {DxDrawerModule, DxListModule, DxTabsModule} from 'devextreme-angular';
import {FlowMeterMetricsModule} from '../flow-meter-metrics/flow-meter-metrics.module';
import {FlowMeterHeatmapModule} from '../flow-meter-heatmap/flow-meter-heatmap.module';



@NgModule({
  declarations: [FlowMeterReportComponent],
  imports: [
    CommonModule,
    DxTabsModule,
    FlowMeterMetricsModule,
    FlowMeterHeatmapModule,
    DxDrawerModule,
    DxListModule
  ],
  exports: [FlowMeterReportComponent]
})
export class FlowMeterReportModule { }
